<template>
  <div class="management-bd partner-service">
    <div class="management-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <el-input
              :placeholder="$t('crm_partner-service.fwgsmc')"
              v-model="formSearch.search"
              clearable
              @keyup.enter.native="onPageChange({ page: 1 })"
              style="width: 280px"
            >
              <template slot="append">
                <div @click="onPageChange({ page: 1 })">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          ref="tb1"
          v-loading="isLoading"
          :data="contractList"
          tableCode="crm_company"
          height="100%"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
           @column="setColumn"
          :filterArr="['action']"
          :slots="['partnerName']"
        >
          <template v-slot:partnerName="scope">
            <div class="cell-link" @click="jump('/distributor/serviceCompany/detail', {  parentPath: $route.fullPath, companyId: scope.row.partnerId, bizType: scope.row.partnerType })">{{ scope.row.partnerName }}</div>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';


export default {
  props: ['partnerOrgId'],
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        orgId: '',
      },
      dataTimes: [],
      totalRows: null,
      isLoading: false,

      contractList: [],
      // 合同类型

      // 操作
      visibleSet: '',
      dialogSetData: {},

      // 查看更多
      more: true,
    };
  },

  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getContract();
  },

  methods: {
    getContract: function () {
      this.isLoading = true;
      this.formSearch.orgId = this.partnerOrgId;
      this.formSearch.bizType = this.bizType;
      this.$getJSON(apis.partnerFactoryService, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          this.contractList = res.data.list;
          this.contractList.forEach((item) => {
            item.more = true;
          });
          this.totalRows = res.data.total;
        }
      });
    },
    toogle: function (item, index) {
      const list = JSON.parse(JSON.stringify(this.contractList));
      list[index] = { ...item, more: !item.more };
      this.contractList = list;
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getContract();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.partner-service {
  height: 100%;
  display: flex;
  flex-direction: column;
  .management-wrap {
    flex: 1;
    // height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
    .morebtn {
      color: $main-color;
    }
  }
}
</style>
